import _ from 'lodash'
import produce from 'immer'
import { Dictionary } from '@feedyou/utils'

import { apiRequest } from '../../../lib/api'
import { getApiUrl } from '../../../apiService'

export async function getLatestSdkVersion(): Promise<string> {
  const remoteVersion = await apiRequest(getApiUrl() + '/sdkVersion', {
    requireToken: true,
    checkOk: true
  })

  return remoteVersion
}

export function getExtraErrors(
  validationErrorsByField: Dictionary<string, string>
): Dictionary<string, any> {
  return produce({}, draft => {
    for (const key in validationErrorsByField) {
      if (!_.get(draft, key + '.__errors')) {
        _.set(draft, key + '.__errors', [])
      }

      _.get(draft, key + '.__errors').push(validationErrorsByField[key])
    }
  })
}
